const state = {
    measure:{
        maxLength:1000,
        overrideMessage: '' //this.$t('kpi.maxLength')
    },
    locale: 'es',
    sector: {}
}

const mutations = {
    setLocale(state, locale){
        
        state.locale = locale;
        localStorage.setItem('locale', locale);

    },
    setSector(state, sector){
        state.sector = sector;
    }
}
const getters = {
    getMeasureMaxLength(base){
        return base.measure.maxLength;
    },
    getMeasureOverrideMessage(base){
        return base.measure.overrideMessage;
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    getters
}